import { Component, Prop, Vue } from 'vue-property-decorator'
import { DynamicList } from '@kwixeo/interface-vue'
import ForecastForm from '../ForecastForm/ForecastForm.vue'
import { BModal } from 'bootstrap-vue'

@Component({
  components: {
    DynamicList,
    BModal
  }
})
export default class ForecastList extends Vue {
  @Prop({ required: true }) modalState!: boolean

  private formComponent = ForecastForm

  get columns (): KwixeoInterface.DynamicListColumns {
    return [
      {
        label: this.$t('dashboard.forecast.list.name'),
        key: 'name'
      },
      {
        label: this.$t('dashboard.forecast.list.begin'),
        key: 'begin'
      },
      {
        label: this.$t('dashboard.forecast.list.end'),
        key: 'end'
      }
    ]
  }
}
